import * as tslib_1 from "tslib";
import Exception from "../exceptions/Exception";
var HttpException = /** @class */ (function (_super) {
    tslib_1.__extends(HttpException, _super);
    function HttpException(status, message, innerException) {
        var _this = _super.call(this, message) || this;
        _this.status = status;
        _this.innerException = innerException;
        return _this;
    }
    return HttpException;
}(Exception));
export { HttpException };
//# sourceMappingURL=HttpException.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/http/HttpException.js
// module id = 10
// module chunks = 1